import { takeLatest } from "redux-saga/effects";
import { getAllCloseCaptionAction } from "./slices";
import { getAllCloseCaptionWorker } from "./workers";

const closeCaptionWatcher = [
  takeLatest(getAllCloseCaptionAction, getAllCloseCaptionWorker),
];

export default closeCaptionWatcher;
